import { createContext } from 'react';

export const VerticalContext = createContext(null);

export default VerticalContext;
